const r = { title: "thereWasAnUnexpectedError", message: ["contactSupportForHelp"] }, s = (e, t) => {
  if (!e) return null;
  switch (e.errorCode) {
    case "29_001":
      return {
        title: "theRequestIsMissingRequiredFieldsOrContainsInvalidData",
        message: ["contactSupportForHelp"],
        onContactSupport: t
      };
    case "30_112":
      return {
        title: "entityWasNotFound",
        message: ["entityWasNotFoundDetail"],
        onContactSupport: t
      };
    case "00_403":
      return r;
    default:
      return null;
  }
};
export {
  r as UNDEFINED_ERROR,
  s as getCommonErrorMessage
};
